<template>
    <div class="pt-5">
        <div class="col-md-4 mx-auto">
            <div class="">
                <div class="text-center my-3">
                    <img src="@/assets/logo1.png" height="100" alt="Logo" loading="lazy" />
                </div>
                <span v-if="verificationIsLoading == true" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                <div class="card login-box">
                    <div class="card-body py-5">
                        <h2 class="text-center mb-4 text-primary">VERIFICATION DU COMPTE</h2>
                        <p>Consultez votre adresse email pour recuperer votre code</p>
                        <form @submit.prevent="verifyAccount()">
                            <div class="input-group mb-3">
                                <Label>Code de verification</Label>
                                <input type="text" class="form-control form-control-lg " required>
                            </div>

                            <div class="text-center">
                                <button type="submit" class="btn btn-lg btn-block btn-primary" :disabled="isLoading">
                                    Verifier
                                    <span v-if="isLoading == true" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                </button>

                                <a href="#" @click.prevent="resendCode()">
                                    Vous n'avez pas reçu de code de verification par mail ? Renvoyer
                                </a>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'LoginView',
    data() {
        return {
            isLoading: false,
            verificationIsLoading: false,
            form: {
                userId: this.$store.state.user.id
            }
        }
    },
    methods: {
        resendCode(){
            this.verificationIsLoading = true
            this.axios.post('/api/send-verification-code', this.form).then(response => {
                if (response.data.success === true) {
                    this.$router.push({ name: 'login' })
                    this.resetForm()
                }
                else {
                    this.$toast.add({
                        severity: 'error',
                        detail: response.data.errors[0],
                        life: 5000
                    });
                }
                this.verificationIsLoading = false
            }).catch(() => {
                this.verificationIsLoading = false
            })
        },
        verifyAccount() {
            this.isLoading = true
            this.axios.post('/api/verify-account', this.form).then(response => {
                if (response.data.success === true) {
                    this.$router.push({ name: 'accueil' })
                    this.resetForm()
                }
                else {
                    this.$toast.add({
                        severity: 'error',
                        detail: response.data.errors[0],
                        life: 5000
                    });
                }
                this.isLoading = false
            }).catch(() => {
                this.isLoading = false
            })
        },
        resetForm() {
            this.form = {
                userId: this.$store.state.user.id
            }
        }
    }
}
</script>

<style>
.login-box {
    min-width: 300px;
    max-width: 350px;
    margin: auto;
}
</style>